module.exports = __webpack_public_path__ + "static/img/B3智慧云平台.bcd7b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/自动驾驶作业系统SAD300/B3智慧云平台.png
// module id = I3t2
// module chunks = 0